​import { actionTypes } from '../actionTypes';
import * as  apiService from '../apiService'

export function fetchAllOpenModsReport() {
    return (dispatch: any) => {
        dispatch(fetchOpenModsReportBegin());
        return fetch(apiService.openModsReport())
            .then(handleErrors)
            .then(res => res.json())
            .then(json => {
                dispatch(fetchOpenModeReportSuccess(json.data));
                return json.data;
            })
            .catch(error => dispatch(fetchOpenModsReportFailure(error)));
    };
}

export const fetchOpenModsReportBegin = () => ({
    type: actionTypes.LOAD_OPEN_MODE_REPORT_BEGIN
});

export const fetchOpenModeReportSuccess = (OpenModsReport: any) => ({
    type: actionTypes.LOAD_OPEN_MODE_REPORT_SUCCESS,
    payload: { OpenModsReport }
});

export const fetchOpenModsReportFailure = (error: any) => ({
    type: actionTypes.LOAD_OPEN_MODE_REPORT_FAILURE,
    payload: { error }
});

// Handle HTTP errors since fetch won't.
function handleErrors(response: any) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}



// WEBPACK FOOTER //
// ./src/store/openModsReport/actions.ts